import { configureStore, createSlice, createAsyncThunk  } from '@reduxjs/toolkit'
import axios from 'axios'; // axios 라이브러리를 추가
import config from './config';






// systemTime 슬라이스 정의
let systemTime = createSlice({
  name: 'systemTime',
  initialState: {
    sunrise: '',
    sunset: '',
    nowtime: '2000 01/01 (월) 00:00:00',
  },
  reducers: {
    updateTime(state, action) {
      return { ...state, ...action.payload };
    }
  }
});
// 액션과 리듀서 내보내기
export let { updateTime } = systemTime.actions;


// plantInfo 슬라이스 정의
let plantInfo = createSlice({
  name: 'plantInfo',
  initialState: {
    name: '',
    address: '',
    callnumber: '',
    logo: '',
  },
  reducers: {
    setPlantInfo(state, action) {
      return { ...state, ...action.payload };
    },
    setName(state, action) {
      state.name = action.payload;
    },
    setAddress(state, action) {
      state.address = action.payload;
    },
    setCallNumber(state, action) {
      state.callnumber = action.payload;
    },
    setLogo(state, action) {
      state.logo = action.payload;
    }
  }
});
// 액션과 리듀서 내보내기
export let { setPlantInfo, setName, setAddress, setCallNumber, setLogo } = plantInfo.actions;




//--- 계측장비에서 현재 선택된 인버터 장비 정보 및 저장
let StateSelDeviceIv = createSlice({
  name : 'StateSelDeviceIv',
  initialState : null,
  reducers : {
    changeStateSelDeviceIv(state, action) {
      return action.payload; // 액션으로 전달된 값을 상태로 저장
    }
  }
}) 
// 액션과 리듀서 내보내기
export let {changeStateSelDeviceIv} = StateSelDeviceIv.actions



//--- 계측장비에서 현재 선택된 접속함 장비 정보 및 저장
let StateSelDeviceJb = createSlice({
  name : 'StateSelDeviceJb',
  initialState : null,
  reducers : {
    changeStateSelDeviceJb(state, action) {
      return action.payload; // 액션으로 전달된 값을 상태로 저장
    }
  }
}) 
// 액션과 리듀서 내보내기
export let {changeStateSelDeviceJb} = StateSelDeviceJb.actions




//--- 계측장비에서 현재 선택된 접속함 장비 정보 및 저장
let StateSelDeviceEv = createSlice({
  name : 'StateSelDeviceEv',
  initialState : null,
  reducers : {
    changeStateSelDeviceEv(state, action) {
      return action.payload; // 액션으로 전달된 값을 상태로 저장
    }
  }
}) 
// 액션과 리듀서 내보내기
export let {changeStateSelDeviceEv} = StateSelDeviceEv.actions













// 인버터 데이터의 초기 상태 정의
const initialInverterData = {
  seq : [] ,
  PvTotalVolt : [],
  PvTotalCurrent : [],
  PvPower : [],
  PvChVolt : [[0] * 30],
  PvCurrent : [[0] * 30],
  Grid_RS_Volt : [],
  Grid_ST_Volt : [],
  Grid_TR_Volt : [],
  Grid_R_Current : [],
  Grid_S_Current : [],
  Grid_T_Current : [],
  Grid_Power : [],
  Grid_Factor : [],
  Grid_Frq : [],
  Add_power : [],
  Process_Add_power : [],
  temperature : [],
  state : [],
  Error : [[]],
  sendCount : [],
  receiveCount : [],
  Mppt_Volt : [[0] * 15],
  Mppt_Current : [[0] * 15],
  todayAdd : [],
  thisMonthAdd : [],
  thisYearAdd : [],
  Pfault: [],
  mode: [], 
  Warn: [],
  fault0: [],
  fault1: [],
  fault2: [],
  fault3: [],
  fault4: [],
  schedule: [],
};
// 새로운 Slice 생성
const ivData = createSlice({
  name: 'ivData',
  initialState: initialInverterData,
  reducers: {

    updateIvData: (state, action) => {
      const { seq, ...data } = action.payload;
      const index = state.seq.indexOf(seq); // 시퀀스에 해당하는 인덱스 찾기

      if (index !== -1) {
        // 시퀀스가 있을 때 해당 인덱스 업데이트
        state.seq[index] = seq;
        state.PvTotalVolt[index] = data.PvTotalVolt;
        state.PvTotalCurrent[index] = data.PvTotalCurrent;
        state.PvPower[index] = data.PvPower;
        state.PvChVolt[index] = [...data.PvChVolt]; // 배열 복사
        state.PvCurrent[index] = [...data.PvCurrent]; // 배열 복사
        state.Grid_RS_Volt[index] = data.Grid_RS_Volt;
        state.Grid_ST_Volt[index] = data.Grid_ST_Volt;
        state.Grid_TR_Volt[index] = data.Grid_TR_Volt;
        state.Grid_R_Current[index] = data.Grid_R_Current;
        state.Grid_S_Current[index] = data.Grid_S_Current;
        state.Grid_T_Current[index] = data.Grid_T_Current;
        state.Pfault[index] = data.Pfault;
        state.mode[index] = data.mode;
        state.Warn[index] = data.Warn;
        state.fault0[index] = data.fault0;
        state.fault1[index] = data.fault1;
        state.fault2[index] = data.fault2;
        state.fault3[index] = data.fault3;
        state.fault4[index] = data.fault4;
        state.Grid_Power[index] = data.Grid_Power;
        state.Grid_Factor[index] = data.Grid_Factor;
        state.Grid_Frq[index] = data.Grid_Frq;
        state.Add_power[index] = data.Add_power;
        state.Process_Add_power[index] = data.Process_Add_power;
        state.temperature[index] = data.temperature;
        state.state[index] = data.state;
        state.Error[index] = [...data.Error]; // 배열 복사
        state.sendCount[index] = data.sendCount;
        state.receiveCount[index] = data.receiveCount;
        state.Mppt_Volt[index] = [...data.Mppt_Volt]; // 배열 복사
        state.Mppt_Current[index] = [...data.Mppt_Current]; // 배열 복사 
        state.todayAdd[index] = data.todayAdd;
        state.thisMonthAdd[index] = data.thisMonthAdd;
        state.thisYearAdd[index] = data.thisYearAdd;
        state.schedule[index] = data.schedule;
      } else {
        // 시퀀스가 없을 때 새로운 데이터 추가
        state.seq.push(seq);
        state.PvTotalVolt.push(data.PvTotalVolt ?? 0);
        state.PvTotalCurrent.push(data.PvTotalCurrent ?? 0);
        state.PvPower.push(data.PvPower ?? 0);
        state.PvChVolt.push(Array.isArray(data.PvChVolt) ? [...data.PvChVolt] : Array(30).fill(0)); // 기본값 추가
        state.PvCurrent.push(Array.isArray(data.PvCurrent) ? [...data.PvCurrent] : Array(30).fill(0)); // 기본값 추가
        state.Grid_RS_Volt.push(data.Grid_RS_Volt ?? 0);
        state.Grid_ST_Volt.push(data.Grid_ST_Volt ?? 0);
        state.Grid_TR_Volt.push(data.Grid_TR_Volt ?? 0);
        state.Grid_R_Current.push(data.Grid_R_Current ?? 0);
        state.Grid_S_Current.push(data.Grid_S_Current ?? 0);
        state.Grid_T_Current.push(data.Grid_T_Current ?? 0);
        state.Pfault.push(data.Pfault ?? 0);
        state.mode.push(data.mode ?? 0);
        state.Warn.push(data.Warn ?? 0);
        state.fault0.push(data.fault0 ?? 0);
        state.fault1.push(data.fault1 ?? 0);
        state.fault2.push(data.fault2 ?? 0);
        state.fault3.push(data.fault3 ?? 0);
        state.fault4.push(data.fault4 ?? 0);
        state.Grid_Power.push(data.Grid_Power ?? 0);
        state.Grid_Factor.push(data.Grid_Factor ?? 0);
        state.Grid_Frq.push(data.Grid_Frq ?? 0);
        state.Add_power.push(data.Add_power ?? 0);
        state.Process_Add_power.push(data.Process_Add_power ?? 0);
        state.temperature.push(data.temperature ?? 0);
        state.state.push(data.state ?? 0);
        state.Error.push(Array.isArray(data.Error) ? [...data.Error] : [0]); // 기본값 추가
        state.sendCount.push(data.sendCount ?? 0);
        state.receiveCount.push(data.receiveCount ?? 0);
        state.Mppt_Volt.push(Array.isArray(data.Mppt_Volt) ? [...data.Mppt_Volt] : Array(15).fill(0)); // 기본값 추가
        state.Mppt_Current.push(Array.isArray(data.Mppt_Current) ? [...data.Mppt_Current] : Array(15).fill(0)); // 기본값 추가
        state.todayAdd.push(data.todayAdd ?? 0);
        state.thisMonthAdd.push(data.thisMonthAdd ?? 0);
        state.thisYearAdd.push(data.thisYearAdd ?? 0);
        state.schedule.push(data.schedule ?? 0);
 
      }
    },

  },
});
// 액션과 리듀서 내보내기
export const { updateIvData } = ivData.actions;





// 환경센서 데이터의 초기 상태 정의
const initialEvData = {
  seq : [] ,
  sun : [],
  temperature : [],
  state : [],
  Error : [[]],
  sendCount : [],
  receiveCount : [],
  todayAdd : [],
  thisMonthAdd : [],
  thisYearAdd : [],
  // WH-2300S 확장 필드
  family_code: [],
  security_code: [],
  fix: [],
  low_battery: [],
  wind_direction: [],
  wind_direction_raw: [],
  wind_speed: [],
  wind_speed_mps: [],
  wind_speed_raw: [],
  gust_speed: [],
  gust_speed_mps: [],
  gust_speed_raw: [],
  temperature_raw: [],
  humidity: [],
  humidity_raw: [],
  rain_counter: [],
  rainfall: [],
  rainfall_mm: [],
  uv_index: [],
  uv_raw: [],
  light: [],
  light_lux: [],
  light_raw: [],
  received_crc: [],
  calculated_crc: [],
};

const EV_WH2300S_FIELDS = [
  'family_code',
  'security_code',
  'fix',
  'low_battery',
  'wind_direction',
  'wind_direction_raw',
  'wind_speed',
  'wind_speed_mps',
  'wind_speed_raw',
  'gust_speed',
  'gust_speed_mps',
  'gust_speed_raw',
  'temperature_raw',
  'humidity',
  'humidity_raw',
  'rain_counter',
  'rainfall',
  'rainfall_mm',
  'uv_index',
  'uv_raw',
  'light',
  'light_lux',
  'light_raw',
  'received_crc',
  'calculated_crc',
];

// 새로운 Slice 생성
const evData = createSlice({
  name: 'evData',
  initialState: initialEvData,
  reducers: {
    updateEvData: (state, action) => {
      const { seq, ...data } = action.payload;
      const index = state.seq.indexOf(seq); // 시퀀스에 해당하는 인덱스 찾기

      if (index !== -1) {
        // 시퀀스가 있을 때 해당 인덱스 업데이트
        state.seq[index] = seq;
        state.sun[index] = data.sun;
        state.temperature[index] = data.temperature;
        state.state[index] = data.state;
        state.Error[index] = [...data.Error]; // 배열 복사
        state.sendCount[index] = data.sendCount;
        state.receiveCount[index] = data.receiveCount;
        state.todayAdd[index] = data.todayAdd;
        state.thisMonthAdd[index] = data.thisMonthAdd;
        state.thisYearAdd[index] = data.thisYearAdd;
        EV_WH2300S_FIELDS.forEach((key) => {
          state[key][index] = data[key] ?? (key === 'low_battery' ? false : 0);
        });
      } else {
        // 시퀀스가 없을 때 새로운 데이터 추가
        state.seq.push(seq);
        state.sun.push(data.sun ?? 0);
        state.temperature.push(data.temperature ?? 0);
        state.state.push(data.state ?? 0);
        state.Error.push(Array.isArray(data.Error) ? [...data.Error] : [0]); // 기본값 추가
        state.sendCount.push(data.sendCount ?? 0);
        state.receiveCount.push(data.receiveCount ?? 0);
        state.todayAdd.push(data.todayAdd ?? 0);
        state.thisMonthAdd.push(data.thisMonthAdd ?? 0);
        state.thisYearAdd.push(data.thisYearAdd ?? 0);
        EV_WH2300S_FIELDS.forEach((key) => {
          state[key].push(data[key] ?? (key === 'low_battery' ? false : 0));
        });
      }
    },
  },
});
// 액션과 리듀서 내보내기
export const { updateEvData } = evData.actions;








// 엠알티 표준 접속함 데이터의 초기 상태 정의
const initialJbMrtData = {
  seq : [] ,
  PvTotalVolt : [] ,
  pvTotalCurrent : [] ,
  pvChVolt : [[]] ,
  pvChCurrent : [[]] ,
  temperature : [],
  specialMode : [[]],
  fire : [],
  // 지투파워 확장 필드
  relayStatus: [[]],
  arcCount: [[]],
  tevDb: [],
  tevCnt: [],
  // 지투파워 설정값
  setarcCount: [],
  setTemp: [],
  // 한빛 확장 필드
  leakCurrent_hanbit: [[]],
  sendCount : [],
  receiveCount : [],
  // 비엔엠 확장 필드
  coValue: [],
  coAlarmSetting: [],
  tempAlarmSetting: [],
  maxTemp: [],
  leakCurrent: [[]],
  leakSetting: [[]],

};
// 새로운 Slice 생성
const JbMrtData = createSlice({
  name: 'JbMrtData',
  initialState: initialJbMrtData,
  reducers: {
    updateJbMrtData: (state, action) => {
      const { seq, ...data } = action.payload;
      const index = state.seq.indexOf(seq); // 시퀀스에 해당하는 인덱스 찾기
      if (index !== -1) {
        // 시퀀스가 있을 때 해당 인덱스 업데이트
        state.seq[index] = seq;
        state.PvTotalVolt[index] = data.PvTotalVolt;
        state.pvTotalCurrent[index] = data.pvTotalCurrent;
        state.pvChVolt[index] = [...data.pvChVolt]; // 배열 복사
        state.pvChCurrent[index] = [...data.pvChCurrent]; // 배열 복사
        state.temperature[index] = data.temperature;
        state.specialMode[index] = [...data.specialMode]; // 배열 복사
        state.fire[index] = data.fire;
        // 확장 필드 업데이트 (배열 길이 보정)
        state.relayStatus[index] = Array.isArray(data.relayStatus) ? [...data.relayStatus] : [];
        state.arcCount[index] = Array.isArray(data.arcCount) ? [...data.arcCount] : [];
        state.tevDb[index] = data.tevDb ?? 0;
        state.tevCnt[index] = data.tevCnt ?? 0;
        // 지투파워 설정값 업데이트
        state.setarcCount[index] = data.setarcCount ?? 0;
        state.setTemp[index] = data.setTemp ?? 0;
        // 한빛 확장 필드
        state.leakCurrent_hanbit[index] = Array.isArray(data.leakCurrent_hanbit) ? [...data.leakCurrent_hanbit] : [];
        state.sendCount[index] = data.sendCount;
        state.receiveCount[index] = data.receiveCount;
        // 비엔엠 확장 필드 업데이트
        state.coValue[index] = data.coValue ?? 0;
        state.coAlarmSetting[index] = data.coAlarmSetting ?? 0;
        state.tempAlarmSetting[index] = data.tempAlarmSetting ?? 0;
        state.maxTemp[index] = data.maxTemp ?? 0;
        state.leakCurrent[index] = Array.isArray(data.leakCurrent) ? [...data.leakCurrent] : [];
        state.leakSetting[index] = Array.isArray(data.leakSetting) ? [...data.leakSetting] : [];

      } else {
        // 시퀀스가 없을 때 새로운 데이터 추가
        state.seq.push(seq);
        state.PvTotalVolt.push(data.PvTotalVolt ?? 0);
        state.pvTotalCurrent.push(data.pvTotalCurrent ?? 0);
        state.pvChVolt.push(Array.isArray(data.pvChVolt) ? [...data.pvChVolt] : [0]); // 기본값 추가
        state.pvChCurrent.push(Array.isArray(data.pvChCurrent) ? [...data.pvChCurrent] : [0]); // 기본값 추가
        state.temperature.push(data.temperature ?? 0);
        state.specialMode.push(Array.isArray(data.specialMode) ? [...data.specialMode] : [0]); // 기본값 추가
        state.fire.push(data.fire ?? 0);
        state.relayStatus.push(Array.isArray(data.relayStatus) ? [...data.relayStatus] : []);
        state.arcCount.push(Array.isArray(data.arcCount) ? [...data.arcCount] : []);
        state.tevDb.push(data.tevDb ?? 0);
        state.tevCnt.push(data.tevCnt ?? 0);
        // 지투파워 설정값 추가
        state.setarcCount.push(data.setarcCount ?? 0);
        state.setTemp.push(data.setTemp ?? 0);
        // 한빛 확장 필드 추가
        state.leakCurrent_hanbit.push(Array.isArray(data.leakCurrent_hanbit) ? [...data.leakCurrent_hanbit] : []);
        state.sendCount.push(data.sendCount ?? 0);
        state.receiveCount.push(data.receiveCount ?? 0);
        // 비엔엠 확장 필드 추가
        state.coValue.push(data.coValue ?? 0);
        state.coAlarmSetting.push(data.coAlarmSetting ?? 0);
        state.tempAlarmSetting.push(data.tempAlarmSetting ?? 0);
        state.maxTemp.push(data.maxTemp ?? 0);
        state.leakCurrent.push(Array.isArray(data.leakCurrent) ? [...data.leakCurrent] : []);
        state.leakSetting.push(Array.isArray(data.leakSetting) ? [...data.leakSetting] : []);

      }
    },
  },
});
// 액션과 리듀서 내보내기
export const { updateJbMrtData } = JbMrtData.actions;





const initialJkVbV1SettingData = {

  SetLevelALow: 0,
  SetLevelAMid: 0,
  SetLevelAHigh: 0,
  SetLevelYLow: 0,
  SetLevelYMid: 0,
  SetLevelYHigh: 0,
  SetAlarmAUse: 0,
  SetAlarmYUse: 0,
  SetAlarmCount: 0,
  SMS_Number_Setting: 0,
  SMS_Api_Key: 0,
  SMS_Callback_Number: 0

};

const JkVbV1SettingData = createSlice({
  name: 'JkVbV1SettingData',
  initialState: initialJkVbV1SettingData,
  reducers: {
    updateJkVbV1SettingData: (state, action) => {
      // console.log('업데이트된 설정 데이터:', action.payload); // 업데이트된 설정 데이터 로그 표시
      return { ...state, ...action.payload };
    },
  },
});

// 액션과 리듀서 내보내기
export const { updateJkVbV1SettingData } = JkVbV1SettingData.actions;




const initialJkVbV1Data = {
  seq: [],
  Id: [], // id 추가
  Ax: [[]],
  Ay: [[]],
  Az: [[]],
  Yx: [[]],
  Yy: [[]],
  Yz: [[]],
  Vibration: [[]],
  ZeroAx: [[]],
  ZeroAy: [[]],
  ZeroAz: [[]],
  ZeroYx: [[]],
  ZeroYy: [[]],
  ZeroYz: [[]],
  specialMode: [[]],
  sendCount: [],
  receiveCount: [],
};
const JkVbV1Data = createSlice({
  name: 'JkVbV1Data',
  initialState: initialJkVbV1Data,
  reducers: {
    updateJkVbV1Data: (state, action) => {
      const { seq, Id, ...data } = action.payload;
      
      // 먼저 모든 배열의 길이를 seq 배열 길이와 맞추기
      const cleanupArrays = () => {
        const seqLength = state.seq.length;
        if (seqLength === 0) return;

        // 모든 배열을 seq 길이에 맞춤
        state.Id.length = seqLength;
        state.Ax.length = seqLength;
        state.Ay.length = seqLength;
        state.Az.length = seqLength;
        state.Yx.length = seqLength;
        state.Yy.length = seqLength;
        state.Yz.length = seqLength;
        state.Vibration.length = seqLength;
        state.ZeroAx.length = seqLength;
        state.ZeroAy.length = seqLength;
        state.ZeroAz.length = seqLength;
        state.ZeroYx.length = seqLength;
        state.ZeroYy.length = seqLength;
        state.ZeroYz.length = seqLength;
        state.specialMode.length = seqLength;
        state.sendCount.length = seqLength;
        state.receiveCount.length = seqLength;
      };

      // 데이터 유효성 검사 및 기본값 설정
      const Ax = Array.isArray(data.Ax) ? data.Ax : [[]];
      const Ay = Array.isArray(data.Ay) ? data.Ay : [[]];
      const Az = Array.isArray(data.Az) ? data.Az : [[]];
      const Yx = Array.isArray(data.Yx) ? data.Yx : [[]];
      const Yy = Array.isArray(data.Yy) ? data.Yy : [[]];
      const Yz = Array.isArray(data.Yz) ? data.Yz : [[]];
      const Vibration = Array.isArray(data.Vibration) ? data.Vibration : [[]];
      const ZeroAx = Array.isArray(data.ZeroAx) ? data.ZeroAx : [[]];
      const ZeroAy = Array.isArray(data.ZeroAy) ? data.ZeroAy : [[]];
      const ZeroAz = Array.isArray(data.ZeroAz) ? data.ZeroAz : [[]];
      const ZeroYx = Array.isArray(data.ZeroYx) ? data.ZeroYx : [[]];
      const ZeroYy = Array.isArray(data.ZeroYy) ? data.ZeroYy : [[]];
      const ZeroYz = Array.isArray(data.ZeroYz) ? data.ZeroYz : [[]];
      const specialMode = Array.isArray(data.specialMode) ? data.specialMode : [[]];

      const index = state.seq.indexOf(seq);
      if (index !== -1) {
        // seq가 이미 존재하면 상태 업데이트
        state.Id[index] = Id;
        state.Ax[index] = [...Ax];
        state.Ay[index] = [...Ay];
        state.Az[index] = [...Az];
        state.Yx[index] = [...Yx];
        state.Yy[index] = [...Yy];
        state.Yz[index] = [...Yz];
        state.Vibration[index] = [...Vibration];
        state.ZeroAx[index] = [...ZeroAx];
        state.ZeroAy[index] = [...ZeroAy];
        state.ZeroAz[index] = [...ZeroAz];
        state.ZeroYx[index] = [...ZeroYx];
        state.ZeroYy[index] = [...ZeroYy];
        state.ZeroYz[index] = [...ZeroYz];
        state.specialMode[index] = [...specialMode];
        state.sendCount[index] = data.sendCount ?? 0;
        state.receiveCount[index] = data.receiveCount ?? 0;
      } else {
        // seq가 없으면 새 데이터 추가
        state.seq.push(seq);
        state.Id.push(Id ?? 'Unknown');
        state.Ax.push([...Ax]);
        state.Ay.push([...Ay]);
        state.Az.push([...Az]);
        state.Yx.push([...Yx]);
        state.Yy.push([...Yy]);
        state.Yz.push([...Yz]);
        state.Vibration.push([...Vibration]);
        state.ZeroAx.push([...ZeroAx]);
        state.ZeroAy.push([...ZeroAy]);
        state.ZeroAz.push([...ZeroAz]);
        state.ZeroYx.push([...ZeroYx]);
        state.ZeroYy.push([...ZeroYy]);
        state.ZeroYz.push([...ZeroYz]);
        state.specialMode.push([...specialMode]);
        state.sendCount.push(data.sendCount ?? 0);
        state.receiveCount.push(data.receiveCount ?? 0);
      }

      // 데이터 정리 실행
      cleanupArrays();
    },
  },
});
// 액션과 리듀서 내보내기
export const { updateJkVbV1Data } = JkVbV1Data.actions;








// 비동기 설정 로드 함수
export const fetchSettings = createAsyncThunk(
  'settingList/fetchSettings',
  async (_, { dispatch }) => {  // 수정된 부분: 첫 번째 매개변수를 _로 변경하고 thunkAPI 구조분해
    try {
      const response = await axios.get(`${config.backendUrl}/api/settingList`);
      const data = response.data;

      
      const JkVbV1_Setting = {
        SetLevelALow: data.JkVbV1_Setting?.SetLevelALow ?? 0,
        SetLevelAMid: data.JkVbV1_Setting?.SetLevelAMid ?? 0,
        SetLevelAHigh: data.JkVbV1_Setting?.SetLevelAHigh ?? 0,
        SetLevelYLow: data.JkVbV1_Setting?.SetLevelYLow ?? 0,
        SetLevelYMid: data.JkVbV1_Setting?.SetLevelYMid ?? 0,
        SetLevelYHigh: data.JkVbV1_Setting?.SetLevelYHigh ?? 0,
        SetAlarmAUse: data.JkVbV1_Setting?.SetAlarmAUse ?? 0,
        SetAlarmYUse: data.JkVbV1_Setting?.SetAlarmYUse ?? 0,
        SetAlarmCount: data.JkVbV1_Setting?.SetAlarmCount ?? 0,
        SMS_Number_Setting: data.JkVbV1_Setting?.SMS_Number_Setting ?? 0,
        SMS_Api_Key: data.JkVbV1_Setting?.SMS_Api_Key ?? 0,
        SMS_Callback_Number: data.JkVbV1_Setting?.SMS_Callback_Number ?? 0,
      };

      dispatch(updateJkVbV1SettingData(JkVbV1_Setting));
      return { ...data, JkVbV1_Setting };
    } catch (error) {
      console.error('설정 로드 실패:', error);
      throw error;
    }
  }
);

// settingList의 초기 상태를 정의
const initialSettingState = {
  iv_protocolList: [],
  commPortList: [],
  jb_protocolList: [],
  sensor_protocolList: [],
  etcMeter_protocolList: [],
  JkVbV1_Setting: [],
  SMS_Number_Setting: [],
  Etc_Setting: [],
  Dashboard_protocollist: [],
};

const settingListSlice = createSlice({
  name: 'settingList',
  initialState: initialSettingState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchSettings.fulfilled, (state, action) => {
        return { ...state, ...action.payload };
      })
      .addCase(fetchSettings.rejected, (state, action) => {
        console.error('Failed to load settings:', action.error);
      });
  },
});




// 비동기 설정 로드 함수
export const fetchIv_list = createAsyncThunk(
  'Iv_list/fetchIv_list',
  async () => {
    const response = await axios.get(`${config.backendUrl}/api/inverters`);
    return response.data;
  }
);

// Iv_list의  초기 상태를 정의
const initialIv_list = {
  seq: [],
  iv_commPort: [],
  iv_address: [],
  iv_name: [],
  iv_protocol: [],
  iv_capa: [],
  iv_ethernetIp: [],
  iv_ethernetPort: [],
  iv_number_of_PVstrings_per_MPPT: [],
  iv_number_of_mppt: [],
  iv_pv_ch_name: [],
  iv_pv_ch_use: [],
  addpower: [],
};

const Iv_list = createSlice({
  name: 'Iv_list',
  initialState: initialIv_list,
  reducers: {
    
    addInverter: (state, action) => {
      // 새로운 인버터 정보를 추가
      state.iv_commPort.push(action.payload.commPort);
      state.iv_address.push(action.payload.id);
      state.iv_name.push(action.payload.name);
      state.iv_protocol.push(action.payload.protocol);
      state.iv_capa.push(action.payload.capacity);
      state.iv_ethernetIp.push(action.payload.iv_ethernetIp);
      state.iv_ethernetPort.push(action.payload.iv_ethernetPort);
      state.iv_number_of_PVstrings_per_MPPT.push(action.payload.iv_number_of_PVstrings_per_MPPT);
      state.iv_number_of_mppt.push(action.payload.iv_number_of_mppt);
      state.iv_pv_ch_name.push(action.payload.iv_pv_ch_name);
      state.iv_pv_ch_use.push(action.payload.iv_pv_ch_use);
      state.addpower.push(action.payload.addpower ?? 0);
    },

    removeInverter: (state, action) => {
      const { port, index } = action.payload;
      if (state.iv_commPort[index] === port) {
        state.seq.splice(index, 1);
        state.iv_commPort.splice(index, 1);
        state.iv_address.splice(index, 1);
        state.iv_name.splice(index, 1);
        state.iv_protocol.splice(index, 1);
        state.iv_capa.splice(index, 1);
        state.iv_ethernetIp.splice(index, 1);
        state.iv_ethernetPort.splice(index, 1);
        state.iv_number_of_PVstrings_per_MPPT.splice(index, 1);
        state.iv_number_of_mppt.splice(index, 1);
        state.iv_pv_ch_name.splice(index, 1);
        state.iv_pv_ch_use.splice(index, 1);
        state.addpower.splice(index, 1);


      }
    },

  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchIv_list.fulfilled, (state, action) => {
        // 기존 상태를 덮어쓰지 않고, 새로운 데이터를 배열로 넣기
        state.seq = action.payload.map(item => item.seq);
        state.iv_commPort = action.payload.map(item => item.iv_commPort);
        state.iv_address = action.payload.map(item => item.iv_address);
        state.iv_name = action.payload.map(item => item.iv_name);
        state.iv_protocol = action.payload.map(item => item.iv_protocol);
        state.iv_capa = action.payload.map(item => item.iv_capa);
        state.iv_ethernetIp = action.payload.map(item => item.iv_ethernetIp);
        state.iv_ethernetPort = action.payload.map(item => item.iv_ethernetPort);
        state.iv_number_of_PVstrings_per_MPPT = action.payload.map(item => item.iv_number_of_PVstrings_per_MPPT);
        state.iv_number_of_mppt = action.payload.map(item => item.iv_number_of_mppt);
        state.iv_pv_ch_name = action.payload.map(item => item.iv_pv_ch_name);
        state.iv_pv_ch_use = action.payload.map(item => item.iv_pv_ch_use);
        state.addpower = action.payload.map(item => item.addpower ?? 0);


      })
      .addCase(fetchIv_list.rejected, (state, action) => {
        console.error('Failed to load settings:', action.error);
      });
  },
});
// Iv_listSlice에서 removeInverter 액션을 임포트
export const { addInverter, removeInverter} = Iv_list.actions;








// 비동기 EV 리스트 로드 함수
export const fetchEv_list = createAsyncThunk(
  'Ev_list/fetchEv_list',
  async () => {
    const response = await axios.get(`${config.backendUrl}/api/evs`);
    return response.data; // API에서 받은 EV 리스트 데이터를 반환
  }
);


// EV Slice (배열 기반)
const Ev_list = createSlice({
  name: 'Ev_list',
  initialState: {
    seq: [],
    ev_commPort: [],
    ev_address: [],
    ev_name: [],
    ev_protocol: [],
    ev_ethernetIp: [],
    ev_ethernetPort: [],
    ev_temperatureType: [],
    ev_sunType: [],
    time: [],
  },
  reducers: {
    addEv: (state, action) => {
      const newEv = action.payload;
      state.seq.push(newEv.seq);
      state.ev_commPort.push(newEv.commPort);
      state.ev_address.push(newEv.address);
      state.ev_name.push(newEv.name);
      state.ev_protocol.push(newEv.protocol);
      state.ev_ethernetIp.push(newEv.ethernetIp);
      state.ev_ethernetPort.push(newEv.ethernetPort);
      state.ev_temperatureType.push(newEv.ev_temperatureType);
      state.ev_sunType.push(newEv.ev_sunType);
      state.time.push(newEv.time);
    },
    removeEv: (state, action) => {
      const index = action.payload;
      state.seq.splice(index, 1);
      state.ev_commPort.splice(index, 1);
      state.ev_address.splice(index, 1);
      state.ev_name.splice(index, 1);
      state.ev_protocol.splice(index, 1);
      state.ev_ethernetIp.splice(index, 1);
      state.ev_ethernetPort.splice(index, 1);
      state.ev_temperatureType.splice(index, 1);
      state.ev_sunType.splice(index, 1);
      state.time.splice(index, 1);
    },
    updateEv: (state, action) => {
      const { index, updatedEv } = action.payload;
      state.ev_commPort[index] = updatedEv.commPort;
      state.ev_address[index] = updatedEv.address;
      state.ev_name[index] = updatedEv.name;
      state.ev_protocol[index] = updatedEv.protocol;
      state.ev_ethernetIp[index] = updatedEv.ethernetIp;
      state.ev_ethernetPort[index] = updatedEv.ethernetPort;
      state.ev_temperatureType[index] = updatedEv.ev_temperatureType;
      state.ev_sunType[index] = updatedEv.ev_sunType;
      state.time[index] = updatedEv.time;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchEv_list.fulfilled, (state, action) => {
      const data = action.payload;
      state.seq = data.map((ev) => ev.seq);
      state.ev_commPort = data.map((ev) => ev.ev_commPort);
      state.ev_address = data.map((ev) => ev.ev_address);
      state.ev_name = data.map((ev) => ev.ev_name);
      state.ev_protocol = data.map((ev) => ev.ev_protocol);
      state.ev_ethernetIp = data.map((ev) => ev.ev_ethernetIp);
      state.ev_ethernetPort = data.map((ev) => ev.ev_ethernetPort);
      state.ev_temperatureType = data.map((ev) => ev.ev_temperatureType);
      state.ev_sunType = data.map((ev) => ev.ev_sunType);
      state.time = data.map((ev) => ev.time);
    });
  },
});

// 액션과 리듀서 내보내기
export const { addEv, removeEv, updateEv } = Ev_list.actions;








// 비동기 JB 리스트 로드 함수
export const fetchJb_list = createAsyncThunk(
  'Jb_list/fetchJb_list',
  async () => {
    const response = await axios.get(`${config.backendUrl}/api/jbs`);
    try {
      const sample = Array.isArray(response.data) ? response.data.slice(0, 3) : [];
      // console.log('[JB LIST] sample pair_device:', sample.map(it => ({ seq: it.seq, pair_device: it.pair_device })));
    } catch (e) {}
    return response.data; // API에서 받은 JB 리스트 데이터를 반환
  }
);

// JB Slice (배열 기반)
const Jb_list = createSlice({
  name: 'Jb_list',
  initialState: {
    time: [],
    jb_sendCount: [],
    jb_receiveCount: [],
    jb_pv_ch_use: [],
    jb_pv_ch_name: [],
    jb_protocol: [],
    jb_name: [],
    jb_commPort: [],
    jb_address: [],
    seq: [],
    jb_ethernetIp: [],
    jb_ethernetPort: [],
    pair_device: [],
    optima_num: [],
  },
  reducers: {
    addJb: (state, action) => {
      const newJb = action.payload;
      state.time.push(newJb.time);
      state.jb_sendCount.push(newJb.jb_sendCount);
      state.jb_receiveCount.push(newJb.jb_receiveCount);
      state.jb_pv_ch_use.push(newJb.jb_pv_ch_use);
      state.jb_pv_ch_name.push(newJb.jb_pv_ch_name);
      state.jb_protocol.push(newJb.jb_protocol);
      state.jb_name.push(newJb.jb_name);
      state.jb_commPort.push(newJb.jb_commPort);
      state.jb_address.push(newJb.jb_address);
      state.seq.push(newJb.seq);
      state.jb_ethernetIp.push(newJb.jb_ethernetIp);
      state.jb_ethernetPort.push(newJb.jb_ethernetPort);
      state.optima_num.push(newJb.optima_num);
    },
    removeJb: (state, action) => {
      const index = action.payload;
      state.time.splice(index, 1);
      state.jb_sendCount.splice(index, 1);
      state.jb_receiveCount.splice(index, 1);
      state.jb_pv_ch_use.splice(index, 1);
      state.jb_pv_ch_name.splice(index, 1);
      state.jb_protocol.splice(index, 1);
      state.jb_name.splice(index, 1);
      state.jb_commPort.splice(index, 1);
      state.jb_address.splice(index, 1);
      state.seq.splice(index, 1);
      state.jb_ethernetIp.splice(index, 1);
      state.jb_ethernetPort.splice(index, 1);
      state.optima_num.splice(index, 1);
    },
    updateJb: (state, action) => {
      const { index, updatedJb } = action.payload;
      state.time[index] = updatedJb.time;
      state.jb_sendCount[index] = updatedJb.jb_sendCount;
      state.jb_receiveCount[index] = updatedJb.jb_receiveCount;
      state.jb_pv_ch_use[index] = updatedJb.jb_pv_ch_use;
      state.jb_pv_ch_name[index] = updatedJb.jb_pv_ch_name;
      state.jb_protocol[index] = updatedJb.jb_protocol;
      state.jb_name[index] = updatedJb.jb_name;
      state.jb_commPort[index] = updatedJb.jb_commPort;
      state.jb_address[index] = updatedJb.jb_address;
      state.seq[index] = updatedJb.seq;
      state.jb_ethernetIp[index] = updatedJb.jb_ethernetIp;
      state.jb_ethernetPort[index] = updatedJb.jb_ethernetPort;
      state.optima_num[index] = updatedJb.optima_num;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchJb_list.fulfilled, (state, action) => {
      const data = action.payload;
      state.time = data.map((jb) => jb.time);
      state.jb_sendCount = data.map((jb) => jb.jb_sendCount);
      state.jb_receiveCount = data.map((jb) => jb.jb_receiveCount);
      state.jb_pv_ch_use = data.map((jb) => jb.jb_pv_ch_use);
      state.jb_pv_ch_name = data.map((jb) => jb.jb_pv_ch_name);
      state.jb_protocol = data.map((jb) => jb.jb_protocol);
      state.jb_name = data.map((jb) => jb.jb_name);
      state.jb_commPort = data.map((jb) => jb.jb_commPort);
      state.jb_address = data.map((jb) => jb.jb_address);
      state.seq = data.map((jb) => jb.seq);
      state.jb_ethernetIp = data.map((jb) => jb.jb_ethernetIp);
      state.jb_ethernetPort = data.map((jb) => jb.jb_ethernetPort);
      state.pair_device = data.map((jb) => jb.pair_device ?? null);
      state.optima_num = data.map((jb) => jb.optima_num ?? null);
    });
  },
});

// 액션과 리듀서 내보내기
export const { addJb, removeJb, updateJb } = Jb_list.actions;







// 비동기 설정 로드 함수
export const fetchEtc_list = createAsyncThunk(
  'Etc_list/fetchEtc_list',
  async () => {
    const response = await axios.get(`${config.backendUrl}/api/Etc`);
    return response.data;
  }
);

// Etc_list의 초기 상태를 정의
const initialEtc_list = {
  seq: [],
  Etc_commPort: [],
  Etc_address: [],
  Etc_name: [],
  Etc_protocol: [],
  Etc_EtcSetting: [],
  Etc_ethernetIp: [],
  Etc_ethernetPort: [],
  Etc_sendCount: [],
  Etc_receiveCount: [],
};

const Etc_list = createSlice({
  name: 'Etc_list',
  initialState: initialEtc_list,
  reducers: {
    addEtc: (state, action) => {
      // console.log("addEtc payload:", action.payload);  // payload 확인 로그 추가

      // 새로운 Etc 정보를 Redux 상태에 추가
      // seq 및 카운터도 함께 추가하여 배열 길이 불일치로 인한 렌더 문제 방지
      state.seq.push(action.payload.seq ?? Date.now());
      state.Etc_commPort.push(action.payload.commPort);
      state.Etc_address.push(action.payload.id);  // id 값을 확인하고 추가
      state.Etc_name.push(action.payload.name);
      state.Etc_protocol.push(action.payload.protocol);
      state.Etc_EtcSetting.push(action.payload.Etc_EtcSetting);
      state.Etc_ethernetIp.push(action.payload.ip);
      state.Etc_ethernetPort.push(action.payload.port);
      state.Etc_sendCount.push(0);
      state.Etc_receiveCount.push(0);

      // 확인용 로그 추가
      // console.log("Updated Etc_list state:", state.Etc_address);
    },

    removeEtc: (state, action) => {
      const { port, index } = action.payload;
      if (state.Etc_commPort[index] === port) {
        state.seq.splice(index, 1);
        state.Etc_commPort.splice(index, 1);
        state.Etc_address.splice(index, 1);
        state.Etc_name.splice(index, 1);
        state.Etc_protocol.splice(index, 1);
        state.Etc_EtcSetting.splice(index, 1);
        state.Etc_ethernetIp.splice(index, 1);
        state.Etc_ethernetPort.splice(index, 1);
      }
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchEtc_list.fulfilled, (state, action) => {
        // 올바른 필드 이름으로 매핑
        state.seq = action.payload.map(item => item.seq);
        state.Etc_commPort = action.payload.map(item => item.Etc_commPort);
        state.Etc_address = action.payload.map(item => item.Etc_address);
        state.Etc_name = action.payload.map(item => item.Etc_name);
        state.Etc_protocol = action.payload.map(item => item.Etc_protocol);
        state.Etc_EtcSetting = action.payload.map(item => item.Etc_EtcSetting);
        state.Etc_ethernetIp = action.payload.map(item => item.Etc_ethernetIp);
        state.Etc_ethernetPort = action.payload.map(item => item.Etc_ethernetPort);
        state.Etc_sendCount = action.payload.map(item => item.Etc_sendCount);
        state.Etc_receiveCount = action.payload.map(item => item.Etc_receiveCount);
      })
      .addCase(fetchEtc_list.rejected, (state, action) => {
        console.error('Failed to load Etc list:', action.error);
      });
  },
});

export const { addEtc, removeEtc } = Etc_list.actions;



// 비동기 ACB 리스트 로드
export const fetchAcb_list = createAsyncThunk(
  'Acb_list/fetchAcb_list',
  async () => {
    const response = await axios.get(`${config.backendUrl}/api/get-acb`);
    return response.data; // ACB 리스트 배열
  }
);

// 초기 상태
const initialAcb_list = {
  seq: [],
  acb_commPort: [],
  acb_address: [],
  acb_name: [],
  acb_protocol: [],
  acb_ethernetIp: [],
  acb_ethernetPort: [],
  acb_sendCount: [],
  acb_receiveCount: [],
};

const Acb_list = createSlice({
  name: 'Acb_list',
  initialState: initialAcb_list,
  reducers: {
    addAcb: (state, action) => {
      // console.log('addAcb payload:', action.payload);

      // 필요한 필드만 추가 (Etc_list 패턴 그대로)
      state.acb_commPort.push(action.payload.acb_commPort);
      state.acb_address.push(action.payload.acb_address);
      state.acb_name.push(action.payload.acb_name);
      state.acb_protocol.push(action.payload.acb_protocol);
      state.acb_ethernetIp.push(action.payload.acb_ethernetIp);
      state.acb_ethernetPort.push(action.payload.acb_ethernetPort);

      // console.log('Updated ACB state acb_address:', state.acb_address);
    },

    removeAcb: (state, action) => {
      const { port, index } = action.payload; // port = acb_commPort
      if (state.acb_commPort[index] === port) {
        state.seq.splice(index, 1);
        state.acb_commPort.splice(index, 1);
        state.acb_address.splice(index, 1);
        state.acb_name.splice(index, 1);
        state.acb_protocol.splice(index, 1);
        state.acb_ethernetIp.splice(index, 1);
        state.acb_ethernetPort.splice(index, 1);
        state.acb_sendCount.splice(index, 1);
        state.acb_receiveCount.splice(index, 1);
      }
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchAcb_list.fulfilled, (state, action) => {
        // 올바른 필드 이름으로 매핑 (백엔드 결과 배열 기준)
        state.seq = action.payload.map(item => item.seq);
        state.acb_commPort = action.payload.map(item => item.acb_commPort);
        state.acb_address = action.payload.map(item => item.acb_address);
        state.acb_name = action.payload.map(item => item.acb_name);
        state.acb_protocol = action.payload.map(item => item.acb_protocol);
        state.acb_ethernetIp = action.payload.map(item => item.acb_ethernetIp);
        state.acb_ethernetPort = action.payload.map(item => item.acb_ethernetPort);
        state.acb_sendCount = action.payload.map(item => item.acb_sendCount ?? 0);
        state.acb_receiveCount = action.payload.map(item => item.acb_receiveCount ?? 0);
      })
      .addCase(fetchAcb_list.rejected, (state, action) => {
        console.error('Failed to load ACB list:', action.error);
      });
  },
});

export const { addAcb, removeAcb } = Acb_list.actions;

const initialAcbData = {
  seq: [],
  voltage: [],
  current: [],
  power: [],
  Add_power: [],
  add_power1: [],
  add_power2: [],
  add_power3: [],
  sendCount: [],
  receiveCount: [],
  last_receive_time: [],   // number(unixtime) 혹은 문자열 그대로 저장
};

const acbData = createSlice({
  name: 'acbData',
  initialState: initialAcbData,
  reducers: {
    updateAcbData: (state, action) => {
      const {
        seq,
        voltage = 0,
        current = 0,
        power = 0,
        Add_power = 0,
        add_power1 = 0,
        add_power2 = 0,
        add_power3 = 0,
        sendCount = 0,
        receiveCount = 0,
        last_receive_time = 0,
      } = action.payload ?? {};

      const index = state.seq.indexOf(seq); // 동일한 seq 위치 찾기

      if (index !== -1) {
        // 기존 인덱스 업데이트
        state.voltage[index] = voltage;
        state.current[index] = current;
        state.power[index] = power;
        state.Add_power[index] = Add_power;
        state.add_power1[index] = add_power1;
        state.add_power2[index] = add_power2;
        state.add_power3[index] = add_power3;
        state.sendCount[index] = sendCount;
        state.receiveCount[index] = receiveCount;
        state.last_receive_time[index] = last_receive_time;
      } else {
        // 신규 seq 추가
        state.seq.push(seq);
        state.voltage.push(voltage);
        state.current.push(current);
        state.power.push(power);
        state.Add_power.push(Add_power);
        state.add_power1.push(add_power1);
        state.add_power2.push(add_power2);
        state.add_power3.push(add_power3);
        state.sendCount.push(sendCount);
        state.receiveCount.push(receiveCount);
        state.last_receive_time.push(last_receive_time);
      }
    },
  },
});

export const { updateAcbData } = acbData.actions;


// === Relay 접점 제어 실시간 데이터 ===
const initialRelayData = {
  seq: [],
  relayStatus: [], // [[ch1,ch2,ch3,ch4], ...]  1=on, 0=off
  ch1_on: [],
  ch1_off: [],
  ch2_on: [],
  ch2_off: [],
  ch3_on: [],
  ch3_off: [],
  ch4_on: [],
  ch4_off: [],
  sendCount: [],
  receiveCount: [],
  last_receive_time: [],
  state: [],
};

const relayData = createSlice({
  name: 'relayData',
  initialState: initialRelayData,
  reducers: {
    updateRelayData: (state, action) => {
      const {
        seq,
        relayStatus = [0, 0, 0, 0],
        ch1_on = 1,
        ch1_off = 1,
        ch2_on = 50,
        ch2_off = 50,
        ch3_on = 1000,
        ch3_off = 1000,
        ch4_on = 0,
        ch4_off = 0,
        sendCount = 0,
        receiveCount = 0,
        last_receive_time = 0,
        state: deviceState = 0,
      } = action.payload ?? {};

      const status = Array.isArray(relayStatus) && relayStatus.length >= 4
        ? relayStatus.slice(0, 4).map((v) => (v ? 1 : 0))
        : [0, 0, 0, 0];

      const index = state.seq.indexOf(seq);

      if (index !== -1) {
        state.relayStatus[index] = status;
        state.ch1_on[index] = ch1_on;
        state.ch1_off[index] = ch1_off;
        state.ch2_on[index] = ch2_on;
        state.ch2_off[index] = ch2_off;
        state.ch3_on[index] = ch3_on;
        state.ch3_off[index] = ch3_off;
        state.ch4_on[index] = ch4_on;
        state.ch4_off[index] = ch4_off;
        state.sendCount[index] = sendCount;
        state.receiveCount[index] = receiveCount;
        state.last_receive_time[index] = last_receive_time;
        state.state[index] = deviceState;
      } else {
        state.seq.push(seq);
        state.relayStatus.push(status);
        state.ch1_on.push(ch1_on);
        state.ch1_off.push(ch1_off);
        state.ch2_on.push(ch2_on);
        state.ch2_off.push(ch2_off);
        state.ch3_on.push(ch3_on);
        state.ch3_off.push(ch3_off);
        state.ch4_on.push(ch4_on);
        state.ch4_off.push(ch4_off);
        state.sendCount.push(sendCount);
        state.receiveCount.push(receiveCount);
        state.last_receive_time.push(last_receive_time);
        state.state.push(deviceState);
      }
    },
  },
});

export const { updateRelayData } = relayData.actions;



// === Dashboard (send/receive counts only) ===
const initialDashboardData = {
  seq: [],
  sendCount: [],
  receiveCount: [],
};

const dashboardData = createSlice({
  name: 'dashboardData',
  initialState: initialDashboardData,
  reducers: {
    updateDashboardData: (state, action) => {
      let {
        seq,
        sendCount = 0,
        receiveCount = 0,
      } = action.payload ?? {};

      // ✅ seq를 항상 숫자로 강제
      const key = Number(seq);
      if (!Number.isFinite(key)) return; // 잘못된 seq면 무시

      // ✅ 안전 숫자 변환
      const toNum = (v, d = 0) => {
        const n = Number(v);
        return Number.isFinite(n) ? n : d;
      };
      const send = toNum(sendCount, 0);
      const recv = toNum(receiveCount, 0);

      // ✅ 타입 무관하게 동일 seq 찾기
      const idx = state.seq.findIndex(v => Number(v) === key);

      if (idx !== -1) {
        state.sendCount[idx] = send;
        state.receiveCount[idx] = recv;
      } else {
        state.seq.push(key);
        state.sendCount.push(send);
        state.receiveCount.push(recv);
      }
    },
  },
});

export const { updateDashboardData } = dashboardData.actions;


export default configureStore({
  reducer: {
    plantInfo: plantInfo.reducer,
    systemTime: systemTime.reducer,
    StateSelDeviceIv: StateSelDeviceIv.reducer,
    StateSelDeviceJb: StateSelDeviceJb.reducer,
    StateSelDeviceEv: StateSelDeviceEv.reducer,
    settingList: settingListSlice.reducer,
    Iv_list: Iv_list.reducer,
    Ev_list: Ev_list.reducer,
    Jb_list: Jb_list.reducer,
    Etc_list: Etc_list.reducer,
    Acb_list: Acb_list.reducer,
    evData: evData.reducer,
    ivData: ivData.reducer,
    acbData: acbData.reducer,
    relayData: relayData.reducer,
    JbMrtData: JbMrtData.reducer,
    JkVbV1Data: JkVbV1Data.reducer,
    JkVbV1SettingData: JkVbV1SettingData.reducer,
    dashboardData: dashboardData.reducer,

    
  },
});
